import { Col, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';
import { IconSize, IconType, IconWrap } from '@tools/ui/dime';
import { theme } from '@tools/ui-utils/theme.util';

const { Text } = Typography;

const ColActions = styled(Col)`
  height: 40px;
  width: 100%;
  display: inline-flex;
  align-items: center;

  :hover {
    background-color: ${theme.colors.gray.gray2};
  }
`;

const ButtonText = styled(Text)`
  margin-left: 15px;
  color: ${theme.colors.gray.grayBlack};
  font-weight: normal;
  font-size: 14px;
`;

const ActionText = styled.span`
  margin-left: 8px;
`;

type IProps = {
  text: string;
  icon: IconType;
};

const ActionUserProfile: React.FC<React.PropsWithChildren<IProps>> = observer(({ text, icon }) => {
  return (
    <ColActions>
      <ButtonText>
        <IconWrap type={icon} size={IconSize.Small} />
        <ActionText>{text}</ActionText>
      </ButtonText>
    </ColActions>
  );
});

export default ActionUserProfile;
